import React, { useState, useEffect } from "react";
import { Link, Redirect } from "react-router-dom";
import { useForm, Controller } from "react-hook-form";
import { useDispatch } from "react-redux";
// @material-ui/core components
import {
  DialogActions,
  Button,
  LinearProgress,
  TextField,
  CircularProgress,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  InputAdornment,
  IconButton,
  ExpansionPanel,
  ExpansionPanelSummary,
  Typography,
  ExpansionPanelDetails,
  Grid,
} from "@material-ui/core";
// @material-ui/styles
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import EmailIcon from "@material-ui/icons/Email";
import PersonIcon from "@material-ui/icons/Person";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import LockIcon from "@material-ui/icons/Lock";
// core components
import { UsersRepository } from "../UsersRepository";
import { LOCALE } from "../../../../properties/Locale";
import EntityMetadata from "../../../../common/components/EntityMetadata";
import {
  notifyShowSuccessMessage,
  notifyShowErrorMessage,
  triggerRerender,
} from "../../../../common/actions/CommonActions";
import { commissionCreateUserForm } from "./Validations";

export default function CommissionFormComponent(props) {
  const [disabled, setDisabled] = useState(props.disabled);
  const [action] = useState(props.action);
  const [showPassword, setShowPassword] = useState(false);
  const [redirectTo, setRedirectTo] = useState();
  const {
    handleSubmit: userForm,
    register: registerForm,
    errors: errorsUser,
    setValue,
    getValues,
    control,
  } = useForm({ validationSchema: commissionCreateUserForm });
  const dispatch = useDispatch();

  useEffect(() => {
    if (action != "create") {
      loadUser();
    }
  }, []);

  const onSubmit = (values) => {
    props.showLoadingBar();
    if (props.form == "myProfile") {
      props.showLoadingBar();
      UsersRepository.updateMyProfile(values)
        .then((res) => {
          props.hideLoadingBar();
          dispatch(triggerRerender());
          dispatch(
            notifyShowSuccessMessage(LOCALE.user_update_success_message)
          );
          setRedirectTo("/app/profile");
        })
        .catch((err) => {
          props.hideLoadingBar();
          dispatch(notifyShowErrorMessage(err.message));
        });
    } else {
      if (action == "create") {
        values.type = "COMMISSION_USER";
        props.showLoadingBar();
        UsersRepository.createUser(values)
          .then((res) => {
            props.hideLoadingBar();
            dispatch(triggerRerender());
            dispatch(
              notifyShowSuccessMessage(LOCALE.user_create_success_message)
            );
            if (props.form == "myProfile") {
              setRedirectTo("/app/profile");
            } else {
              setRedirectTo("/app/admin/users");
            }
          })
          .catch((err) => {
            props.hideLoadingBar();
            if (err.response?.data?.message) {
              dispatch(notifyShowErrorMessage(err.response?.data?.message));
            } else {
              dispatch(notifyShowErrorMessage(err.message));
            }
          });
      } else {
        props.showLoadingBar();
        UsersRepository.updateUser(values)
          .then((res) => {
            props.hideLoadingBar();
            dispatch(triggerRerender());
            dispatch(
              notifyShowSuccessMessage(LOCALE.user_update_success_message)
            );
            if (props.form == "myProfile") {
              setRedirectTo("/app/profile");
            } else {
              setRedirectTo("/app/admin/users");
            }
          })
          .catch((err) => {
            props.hideLoadingBar();
            dispatch(notifyShowErrorMessage(err.message));
          });
      }
    }
  };

  const loadUser = () => {
    Object.keys(props.data).map(function (item) {
      if (Object.keys(getValues()).indexOf(item) == -1) {
        registerForm({ name: item, type: "custom" });
      }
    });
    Object.entries(props.data).map(function (item) {
      setValue(item[0], item[1]);
    });
  };

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const handleSubmit = () => {
    UsersRepository.resetPassword(getValues())
      .then((res) => {
        props.hideLoadingBar();
        dispatch(triggerRerender());
        dispatch(notifyShowSuccessMessage(LOCALE.user_update_success_message));
        if (props.form == "myProfile") {
          setRedirectTo("/app/profile");
        } else {
          setRedirectTo("/app/admin/users");
        }
      })
      .catch((err) => {
        props.hideLoadingBar();
        dispatch(notifyShowErrorMessage(err.message));
      });
  };

  return (
    <div>
      {redirectTo && <Redirect to={redirectTo} />}
      <div>
        <form onSubmit={userForm(onSubmit)}>
          {action != "create" && (
            <div>
              <FormControl
                variant="outlined"
                fullWidth
                margin="normal"
                size="small"
              >
                <InputLabel>{LOCALE.role}</InputLabel>
                <Controller
                  as={
                    <Select label={LOCALE.role}>
                      <MenuItem value="">None</MenuItem>
                      <MenuItem value="ADMINISTRATOR">
                        {LOCALE.administrator}
                      </MenuItem>
                      <MenuItem value="ADVISOR">{LOCALE.advisor}</MenuItem>
                      <MenuItem value="COMMISSION_USER">
                        {LOCALE.commission}
                      </MenuItem>
                      <MenuItem value="SCHOOL_USER">{LOCALE.school}</MenuItem>
                    </Select>
                  }
                  name="type"
                  control={control}
                  defaultValue=""
                  disabled
                />
              </FormControl>
            </div>
          )}

          <TextField
            id="name"
            label={LOCALE.commission_name}
            name="name"
            fullWidth={true}
            size="small"
            margin="normal"
            variant="outlined"
            inputRef={registerForm}
            InputLabelProps={{ shrink: true }}
            InputProps={{
              disabled: disabled,
              startAdornment: (
                <InputAdornment position="start">
                  <PersonIcon />
                </InputAdornment>
              ),
            }}
            error={errorsUser?.name}
            helperText={errorsUser?.name?.message}
          />

          <TextField
            id="email"
            label={LOCALE.login_email}
            fullWidth={true}
            size="small"
            name="email"
            margin="normal"
            variant="outlined"
            inputRef={registerForm}
            InputLabelProps={{ shrink: true }}
            InputProps={{
              disabled: disabled,
              startAdornment: (
                <InputAdornment position="start">
                  <EmailIcon />
                </InputAdornment>
              ),
            }}
            error={errorsUser?.email}
            helperText={errorsUser?.email?.message}
          />

          <TextField
            id="id"
            label={LOCALE.username}
            fullWidth={true}
            size="small"
            name="username"
            margin="normal"
            variant="outlined"
            inputRef={registerForm}
            InputLabelProps={{ shrink: true }}
            InputProps={{
              disabled: disabled || action != "create",
              startAdornment: (
                <InputAdornment position="start">
                  <PersonIcon />
                </InputAdornment>
              ),
            }}
            error={errorsUser?.username}
            helperText={errorsUser?.username?.message}
          />
          {action === "create" && (
            <Grid item md={12}>
              <TextField
                id="password"
                type={showPassword ? "text" : "password"}
                label={LOCALE.password}
                size="small"
                fullWidth={true}
                margin="dense"
                variant="outlined"
                name="password"
                inputRef={registerForm}
                InputProps={{
                  disabled: disabled,
                  startAdornment: (
                    <InputAdornment position="start">
                      <LockIcon />
                    </InputAdornment>
                  ),
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        edge="end"
                        onClick={handleClickShowPassword}
                      >
                        {showPassword ? <Visibility /> : <VisibilityOff />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                error={errorsUser?.password}
                helperText={errorsUser?.password?.message}
              />
            </Grid>
          )}
          {action === "edit" && (
            <div>
              <ExpansionPanel>
                <ExpansionPanelSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                  <Typography>{LOCALE.user_profile_change_password}</Typography>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails>
                  <Grid container spacing={2}>
                    <Grid item xs={7}>
                      <TextField
                        id="password"
                        type={showPassword ? "text" : "password"}
                        label={LOCALE.password}
                        size="small"
                        fullWidth={true}
                        margin="normal"
                        variant="outlined"
                        name="password"
                        inputRef={registerForm}
                        InputProps={{
                          disabled: disabled,
                          startAdornment: (
                            <InputAdornment position="start">
                              <LockIcon />
                            </InputAdornment>
                          ),
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton
                                aria-label="toggle password visibility"
                                edge="end"
                                onClick={handleClickShowPassword}
                              >
                                {showPassword ? (
                                  <Visibility />
                                ) : (
                                  <VisibilityOff />
                                )}
                              </IconButton>
                            </InputAdornment>
                          ),
                        }}
                        error={errorsUser?.password}
                        helperText={errorsUser?.password?.message}
                      />
                    </Grid>
                    <Grid item xs={4}>
                      <Button
                        fullWidth={true}
                        style={{ verticalAlign: "middle", marginTop: "17px" }}
                        variant="contained"
                        color="secondary"
                        onClick={() => handleSubmit()}
                      >
                        {LOCALE.save}
                      </Button>
                    </Grid>
                  </Grid>
                </ExpansionPanelDetails>
              </ExpansionPanel>
            </div>
          )}
          <EntityMetadata data={getValues()} />
          <DialogActions>
            {!disabled && props.form != "myProfile" && (
              <Link to={`/app/admin/users/`} style={{ textDecoration: "none" }}>
                <Button size="small" variant="outlined" color="secondary">
                  {LOCALE.cancel}
                </Button>
              </Link>
            )}
            {action != "details" && (
              <Button
                type="submit"
                size="small"
                variant="contained"
                disabled={disabled}
                className={disabled ? "btn-loading" : ""}
                color="primary"
              >
                {LOCALE.save}
                {disabled && (
                  <CircularProgress
                    color="secondary"
                    size={20}
                    style={{ position: "absolute" }}
                  />
                )}
              </Button>
            )}
          </DialogActions>
        </form>
      </div>
    </div>
  );
}
